import React from "react";

const SuccessMessage = () => (
  <div className="mt-4 text-center">
    <p className="text-green-600 font-medium">
      Event has been successfully created!
    </p>
  </div>
);

export default SuccessMessage;
